<template>
  <div class="container-fluid">
    <div class="mt-3 my-md-4">
      <nuxt-link
        :to="localePath('Login')"
        class="arrow-left overview"
      >
        {{ $t('backToLogin') }}
      </nuxt-link>
    </div>
    <div class="content-wrap-small content-pad">
      <div class="text-md-center mb-4">
        <h2>
          {{ $t('pwReset.headline') }}
        </h2>
        <p class="md-3 mb-md-5">
          {{ $t('pwReset.subHeadline') }}
        </p>
      </div>
      <dx-pw-reset />
    </div>
  </div>
</template>

<script>
import DxPwReset from '~/domains/authentication/components/DX-PwReset'

export default {
  name: 'PwReset',
  meta: {
    isPublic: true,
  },
  components: {
    DxPwReset,
  },
  nuxtI18n: {
    paths: {
      de: '/pw-zuruecksetzen',
      fr: '/mot-de-passe-oublie',
      it: '/reimposta-password',
    },
  },
}
</script>
